














































import { Component, Prop, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  Col,
  DataTable,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { SortOrder } from '@/types'
import { orderBy } from 'lodash'
import { MailHistory, SystemCode } from '@/api'
import { ModalMailDetail } from '@/components/modals/ModalMailDetail'

const COLS: Col[] = [
  {
    width: 40,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '10',
    items: [
      {
        name: 'type',
        headerText: '種別',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '10',
    items: [
      {
        name: 'sendDateTime',
        headerText: '送信日時',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '20',
    items: [
      {
        name: 'destination',
        headerText: '送信先',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '60',
    items: [
      {
        name: 'body',
        headerText: '本文'
      }
    ]
  }
]

@Component({
  components: {
    ModalMailDetail,
    DataTable
  }
})
export default class UserMailHistoryTable extends ComponentVue {
  @Ref()
  modalMailDetail!: ModalMailDetail

  @Prop({
    type: Array
  })
  items!: MailHistory[]

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  sortName: string = ''

  sortOrder: SortOrder = ''

  get sortedItems(): MailHistory[] {
    if (this.sortName) {
      return orderBy<MailHistory>(
        this.items,
        (item: MailHistory) => {
          const propertyValue = item[this.sortName as keyof MailHistory]
          const type: string = Object.prototype.toString
            .call(propertyValue)
            .slice(8, -1)
            .toLowerCase()

          if (type === 'object') return (propertyValue as SystemCode).name

          return propertyValue
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.items
  }

  get cols(): Col[] {
    return COLS
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }

  displayFirstRow(value: string): string {
    const results: string[] | null = value.match(/^.+\n/)
    return results !== null ? results[0] : ''
  }

  splitNewLine(value: string): string[] {
    return value.split('\n')
  }

  openModalMailDetail(sortedIndex: number): void {
    const mailHistory: MailHistory | undefined = this.items.find(
      item => item.id === this.sortedItems[sortedIndex].id
    )

    if (mailHistory) {
      this.modalMailDetail.open({
        mailHistory
      })
    }
  }
}
